<template>
  <v-app>
    <v-main>
      <v-container fluid>
        <v-row align="center" justify="center" outlined align-content="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12 mx-auto" :loading="!checkedAuth || (checkedAuth && signedIn)">
              <v-card-title>{{ cardTitle }}</v-card-title>
              <v-card-text v-if="checkedAuth && !signedIn">
                <p>We were uanble to sign you in this time. Please try logging in again.</p>
                <p>
                  There is a known issue with logging in from Google where the first
                  attempt fails so a second try should get you in.
                </p>
              </v-card-text>
              <v-card-text v-else-if="checkedAuth && signedIn">
                <p>You're signed in. Redirecting you...</p>
              </v-card-text>
              <v-card-actions>
                <v-btn to="/" left>Back to Home</v-btn>
                <v-spacer />
                <v-btn right to="/login" color="primary">Back to Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Vue from "vue";

export default {
  name: "Callback",
  computed: {
    cardTitle: function() {
      if (!this.checkedAuth) {
        return "Signing you in...";
      }
      else if (!this.signedIn) {
        return "Authentication problem"
      }
      else {
        "Authenticated"
      }
    }
  },
  async created() {

    await this.getUser();

    if (this.checkedAuth && this.signedIn) {
      this.$router.push("/");
    }
  },
  data() {
    return {
      checkedAuth: false,
      signedIn: false,
    };
  },
  methods: {
    getUser: async function () {
      {
        try {
          const user = await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
          if (user && user.signInUserSession) {
            //console.log("getUser got user");
            this.checkedAuth = true;
            this.signedIn = true;
          } else {
            console.log("getUser user invalid");
            this.checkedAuth = true;
            this.signedIn = false;
          }
        } catch (err) {
          console.log("getUser err", err);
          this.checkedAuth = true;
          this.signedIn = false;
        }
      }
    },
  },
};
</script>
